module.exports = new __parcel__URL__("flag-en2.58b21dc2.png").toString();